import {
    type CustomListItem,
    getCustomListCatalogItem,
} from 'entities/CustomList';

const includesQuery = (value: string | null | undefined, query: string) =>
    Boolean(value?.toLowerCase().includes(query));

/**
 * Client-side stand-in until list item search moves to OpenSearch.
 */
export const customListItemMatchesSearch = (
    listItem: CustomListItem,
    query: string,
) => {
    if (!query) {
        return true;
    }

    const catalogItem = getCustomListCatalogItem(listItem);
    if (!catalogItem) {
        return false;
    }

    const supplierSkus =
        catalogItem.proposals?.map((proposal) => proposal.externalInvId) ?? [];

    return [
        catalogItem.title,
        catalogItem.sku,
        catalogItem.brand,
        catalogItem.mpn,
        ...supplierSkus,
    ].some((value) => includesQuery(value, query));
};
